import Kicker from './Kicker';
import SectionShell from './SectionShell';
import { useTranslation } from 'react-i18next';

function ClosedLoopSection() {
  const { t } = useTranslation();
  const loopSteps = [
    { number: '01', label: t('closed_loop.steps.s1_label'), title: t('closed_loop.steps.s1_title'), copy: t('closed_loop.steps.s1_copy') },
    { number: '02', label: t('closed_loop.steps.s2_label'), title: t('closed_loop.steps.s2_title'), copy: t('closed_loop.steps.s2_copy') },
    { number: '03', label: t('closed_loop.steps.s3_label'), title: t('closed_loop.steps.s3_title'), copy: t('closed_loop.steps.s3_copy'), active: true },
    { number: '04', label: t('closed_loop.steps.s4_label'), title: t('closed_loop.steps.s4_title'), copy: t('closed_loop.steps.s4_copy') },
  ];

  return (
    <SectionShell id="closed-loop" dark>
      <div>
        <Kicker dark>{t('closed_loop.kicker')}</Kicker>
        <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:items-end">
          <h2 className="text-4xl font-black leading-tight sm:text-5xl">
            {t('closed_loop.title_prefix')} <span className="text-white">{t('closed_loop.title_highlight')}</span>
          </h2>
          <p className="text-lg leading-8 text-white">
            {t('closed_loop.body')}
          </p>
        </div>

        <div className="mt-10 grid gap-4 lg:grid-cols-4">
          {loopSteps.map((step) => (
            <article
              key={step.number}
              className={`rounded border p-6 ${
                step.active
                  ? 'border-white/10 bg-white/[0.03] text-white'
                  : 'border-white/10 bg-white/[0.03] text-white'
              }`}
            >
              <div className={`text-4xl font-light ${step.active ? 'text-white' : 'text-white'}`}>
                {step.number}
              </div>
              <p className={`mt-6 text-xs font-extrabold uppercase tracking-[0.22em] ${step.active ? 'text-white' : 'text-white'}`}>
                {step.label}
              </p>
              <h3 className="mt-3 text-xl font-black text-white leading-tight">{step.title}</h3>
              <p className={`mt-5 text-sm  leading-6 ${step.active ? 'text-white' : 'text-white'}`}>
                {step.copy}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-10 rounded border border-emerald-500/30 bg-emerald-500/10 p-5 text-lg font-bold">
          {t('closed_loop.callout')}
        </p>
      </div>
    </SectionShell>
  );
}

export default ClosedLoopSection;
